import { dataBabyBottle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBabyBottle = /*#__PURE__*/createIcon(dataBabyBottle)
export default IconBabyBottle
